/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DBHistory,
  DBHistoryOptional,
  DBHistoryMetaI,
  DBHistoryTrackedI,
} from "./dbhistory";
import { DBHistoryTracked, DBHistoryMeta } from "./dbhistory";
// May contain unused imports in some cases
// @ts-ignore
import type {
  EmailContentGroupRef,
  EmailContentGroupRefOptional,
  EmailContentGroupRefMetaI,
  EmailContentGroupRefTrackedI,
} from "./email-content-group-ref";
import {
  EmailContentGroupRefTracked,
  EmailContentGroupRefMeta,
} from "./email-content-group-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OptOutGroupRef,
  OptOutGroupRefOptional,
  OptOutGroupRefMetaI,
  OptOutGroupRefTrackedI,
} from "./opt-out-group-ref";
import { OptOutGroupRefTracked, OptOutGroupRefMeta } from "./opt-out-group-ref";

/**
 *
 * @export
 * @interface EmailContentBase
 */
export interface EmailContentBaseOptional extends DBHistoryOptional {
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  fromAddr?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  ccAddr?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  bccAddr?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  subject?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  plainBody?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  htmlBody?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  title?: string;
  /**
   *
   * @type {EmailContentGroupRef}
   * @memberof EmailContentBase
   */
  emailGroupId?: EmailContentGroupRefOptional;
  /**
   *
   * @type {number}
   * @memberof EmailContentBase
   */
  recGroupId?: number;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  htmlBodyClob?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  fromAddrName?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  fromAddrOnly?: string;
  /**
   *
   * @type {OptOutGroupRef}
   * @memberof EmailContentBase
   */
  optOutGrpId?: OptOutGroupRefOptional;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  replyTo?: string;
  /**
   *
   * @type {boolean}
   * @memberof EmailContentBase
   */
  hidden?: boolean;
}

export interface EmailContentBase extends EmailContentBaseOptional, DBHistory {
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  fromAddr?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  ccAddr?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  bccAddr?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  subject?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  plainBody?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  htmlBody?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  title: string;
  /**
   *
   * @type {EmailContentGroupRef}
   * @memberof EmailContentBase
   */
  emailGroupId?: EmailContentGroupRef;
  /**
   *
   * @type {number}
   * @memberof EmailContentBase
   */
  recGroupId?: number;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  htmlBodyClob?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  fromAddrName?: string;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  fromAddrOnly?: string;
  /**
   *
   * @type {OptOutGroupRef}
   * @memberof EmailContentBase
   */
  optOutGrpId?: OptOutGroupRef;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  replyTo?: string;
  /**
   *
   * @type {boolean}
   * @memberof EmailContentBase
   */
  hidden?: boolean;
}

export interface EmailContentBaseTrackedI extends DBHistoryOptional {
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  updatedOn?: Date;
  updatedOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  updatedBy?: string;
  updatedByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  createdOn?: Date;
  createdOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  createdBy?: string;
  createdByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  fromAddr?: string;
  fromAddrIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  ccAddr?: string;
  ccAddrIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  bccAddr?: string;
  bccAddrIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  subject?: string;
  subjectIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  plainBody?: string;
  plainBodyIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  htmlBody?: string;
  htmlBodyIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  description?: string;
  descriptionIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  title?: string;
  titleIsSet: boolean;
  /**
   *
   * @type {EmailContentGroupRef}
   * @memberof EmailContentBase
   */
  emailGroupId?: EmailContentGroupRefTrackedI;
  emailGroupIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof EmailContentBase
   */
  recGroupId?: number;
  recGroupIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  htmlBodyClob?: string;
  htmlBodyClobIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  fromAddrName?: string;
  fromAddrNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  fromAddrOnly?: string;
  fromAddrOnlyIsSet: boolean;
  /**
   *
   * @type {OptOutGroupRef}
   * @memberof EmailContentBase
   */
  optOutGrpId?: OptOutGroupRefTrackedI;
  optOutGrpIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EmailContentBase
   */
  replyTo?: string;
  replyToIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EmailContentBase
   */
  hidden?: boolean;
  hiddenIsSet: boolean;
}

transformDatesMap.set("EmailContentBase", function (model: EmailContentBase) {
  if (typeof model.updatedOn == "string")
    model.updatedOn = new Date(model.updatedOn);
  if (typeof model.createdOn == "string")
    model.createdOn = new Date(model.createdOn);
  const transformDatesemailGroupId = transformDatesMap.get(
    "EmailContentGroupRef",
  );
  if (transformDatesemailGroupId && model.emailGroupId) {
    transformDatesemailGroupId(model.emailGroupId);
  }
  const transformDatesoptOutGrpId = transformDatesMap.get("OptOutGroupRef");
  if (transformDatesoptOutGrpId && model.optOutGrpId) {
    transformDatesoptOutGrpId(model.optOutGrpId);
  }
});

export type EmailContentBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: true
  updatedOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  updatedBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  createdOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  createdBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  fromAddr: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  ccAddr: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  bccAddr: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  subject: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  plainBody: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  htmlBody: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  description: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  title: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  emailGroupId: PropertyMeta<EmailContentGroupRefMetaI>;
  //isDate: false
  //isDatetime: false
  recGroupId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  htmlBodyClob: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  fromAddrName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  fromAddrOnly: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  optOutGrpId: PropertyMeta<OptOutGroupRefMetaI>;
  //isDate: false
  //isDatetime: false
  replyTo: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  hidden: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var EmailContentBaseMeta: EmailContentBaseMetaI =
  {} as EmailContentBaseMetaI;
EmailContentBaseMeta = typeMeta("EmailContentBase", {
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta(
    "updatedBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta(
    "createdBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  fromAddr: propertyMeta("fromAddr", false, false, false, MetaTypesBase.string),
  ccAddr: propertyMeta("ccAddr", false, false, false, MetaTypesBase.string),
  bccAddr: propertyMeta("bccAddr", false, false, false, MetaTypesBase.string),
  subject: propertyMeta("subject", false, false, false, MetaTypesBase.string),
  plainBody: propertyMeta(
    "plainBody",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  htmlBody: propertyMeta("htmlBody", false, false, false, MetaTypesBase.string),
  description: propertyMeta(
    "description",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  title: propertyMeta("title", false, true, false, MetaTypesBase.string),
  emailGroupId: propertyMeta(
    "emailGroupId",
    false,
    false,
    false,
    EmailContentGroupRefMeta,
  ),
  recGroupId: propertyMeta(
    "recGroupId",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  htmlBodyClob: propertyMeta(
    "htmlBodyClob",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  fromAddrName: propertyMeta(
    "fromAddrName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  fromAddrOnly: propertyMeta(
    "fromAddrOnly",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  optOutGrpId: propertyMeta(
    "optOutGrpId",
    false,
    false,
    false,
    OptOutGroupRefMeta,
  ),
  replyTo: propertyMeta("replyTo", false, false, false, MetaTypesBase.string),
  hidden: propertyMeta("hidden", false, false, false, MetaTypesBase.boolean),
});

const metaI = EmailContentBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DBHistoryMeta]);
  metaI.updatedOn.inheritedFrom = DBHistoryMeta.updatedOn;
  metaI.updatedBy.inheritedFrom = DBHistoryMeta.updatedBy;
  metaI.createdOn.inheritedFrom = DBHistoryMeta.createdOn;
  metaI.createdBy.inheritedFrom = DBHistoryMeta.createdBy;
});

export class EmailContentBaseTracked
  extends DBHistoryTracked
  implements EmailContentBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  updatedOn__I?: Date = undefined;
  updatedOnIsSet: boolean = false;
  set updatedOn(v: undefined | Date) {
    if (v !== undefined) {
      this.updatedOn__I = v;
      this.updatedOnIsSet = true;
    } else {
      this.updatedOn__I = v || undefined;
      this.updatedOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedOn() {
    return this.updatedOn__I;
  }
  updatedBy__I?: string = undefined;
  updatedByIsSet: boolean = false;
  set updatedBy(v: undefined | string) {
    if (v !== undefined) {
      this.updatedBy__I = v;
      this.updatedByIsSet = true;
    } else {
      this.updatedBy__I = v || undefined;
      this.updatedByIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedBy() {
    return this.updatedBy__I;
  }
  createdOn__I?: Date = undefined;
  createdOnIsSet: boolean = false;
  set createdOn(v: undefined | Date) {
    if (v !== undefined) {
      this.createdOn__I = v;
      this.createdOnIsSet = true;
    } else {
      this.createdOn__I = v || undefined;
      this.createdOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdOn() {
    return this.createdOn__I;
  }
  createdBy__I?: string = undefined;
  createdByIsSet: boolean = false;
  set createdBy(v: undefined | string) {
    if (v !== undefined) {
      this.createdBy__I = v;
      this.createdByIsSet = true;
    } else {
      this.createdBy__I = v || undefined;
      this.createdByIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdBy() {
    return this.createdBy__I;
  }
  fromAddr__I?: string = undefined;
  fromAddrIsSet: boolean = false;
  set fromAddr(v: undefined | string) {
    if (v !== undefined) {
      this.fromAddr__I = v;
      this.fromAddrIsSet = true;
    } else {
      this.fromAddr__I = v || undefined;
      this.fromAddrIsSet = false;
    }
    this.changeTracker = true;
  }
  get fromAddr() {
    return this.fromAddr__I;
  }
  ccAddr__I?: string = undefined;
  ccAddrIsSet: boolean = false;
  set ccAddr(v: undefined | string) {
    if (v !== undefined) {
      this.ccAddr__I = v;
      this.ccAddrIsSet = true;
    } else {
      this.ccAddr__I = v || undefined;
      this.ccAddrIsSet = false;
    }
    this.changeTracker = true;
  }
  get ccAddr() {
    return this.ccAddr__I;
  }
  bccAddr__I?: string = undefined;
  bccAddrIsSet: boolean = false;
  set bccAddr(v: undefined | string) {
    if (v !== undefined) {
      this.bccAddr__I = v;
      this.bccAddrIsSet = true;
    } else {
      this.bccAddr__I = v || undefined;
      this.bccAddrIsSet = false;
    }
    this.changeTracker = true;
  }
  get bccAddr() {
    return this.bccAddr__I;
  }
  subject__I?: string = undefined;
  subjectIsSet: boolean = false;
  set subject(v: undefined | string) {
    if (v !== undefined) {
      this.subject__I = v;
      this.subjectIsSet = true;
    } else {
      this.subject__I = v || undefined;
      this.subjectIsSet = false;
    }
    this.changeTracker = true;
  }
  get subject() {
    return this.subject__I;
  }
  plainBody__I?: string = undefined;
  plainBodyIsSet: boolean = false;
  set plainBody(v: undefined | string) {
    if (v !== undefined) {
      this.plainBody__I = v;
      this.plainBodyIsSet = true;
    } else {
      this.plainBody__I = v || undefined;
      this.plainBodyIsSet = false;
    }
    this.changeTracker = true;
  }
  get plainBody() {
    return this.plainBody__I;
  }
  htmlBody__I?: string = undefined;
  htmlBodyIsSet: boolean = false;
  set htmlBody(v: undefined | string) {
    if (v !== undefined) {
      this.htmlBody__I = v;
      this.htmlBodyIsSet = true;
    } else {
      this.htmlBody__I = v || undefined;
      this.htmlBodyIsSet = false;
    }
    this.changeTracker = true;
  }
  get htmlBody() {
    return this.htmlBody__I;
  }
  description__I?: string = undefined;
  descriptionIsSet: boolean = false;
  set description(v: undefined | string) {
    if (v !== undefined) {
      this.description__I = v;
      this.descriptionIsSet = true;
    } else {
      this.description__I = v || undefined;
      this.descriptionIsSet = false;
    }
    this.changeTracker = true;
  }
  get description() {
    return this.description__I;
  }
  title__I?: string = undefined;
  titleIsSet: boolean = false;
  set title(v: undefined | string) {
    if (v !== undefined) {
      this.title__I = v;
      this.titleIsSet = true;
    } else {
      this.title__I = v || undefined;
      this.titleIsSet = true;
    }
    this.changeTracker = true;
  }
  get title() {
    return this.title__I;
  }
  emailGroupId__I?: EmailContentGroupRefTracked = undefined;
  emailGroupIdIsSet: boolean = false;
  set emailGroupId(v: undefined | EmailContentGroupRefTracked) {
    if (v !== undefined) {
      this.emailGroupId__I = v;
      this.emailGroupIdIsSet = true;
    } else {
      this.emailGroupId__I = v || undefined;
      this.emailGroupIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get emailGroupId() {
    return this.emailGroupId__I;
  }
  recGroupId__I?: number = undefined;
  recGroupIdIsSet: boolean = false;
  set recGroupId(v: undefined | number) {
    if (v !== undefined) {
      this.recGroupId__I = v;
      this.recGroupIdIsSet = true;
    } else {
      this.recGroupId__I = v || undefined;
      this.recGroupIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get recGroupId() {
    return this.recGroupId__I;
  }
  htmlBodyClob__I?: string = undefined;
  htmlBodyClobIsSet: boolean = false;
  set htmlBodyClob(v: undefined | string) {
    if (v !== undefined) {
      this.htmlBodyClob__I = v;
      this.htmlBodyClobIsSet = true;
    } else {
      this.htmlBodyClob__I = v || undefined;
      this.htmlBodyClobIsSet = false;
    }
    this.changeTracker = true;
  }
  get htmlBodyClob() {
    return this.htmlBodyClob__I;
  }
  fromAddrName__I?: string = undefined;
  fromAddrNameIsSet: boolean = false;
  set fromAddrName(v: undefined | string) {
    if (v !== undefined) {
      this.fromAddrName__I = v;
      this.fromAddrNameIsSet = true;
    } else {
      this.fromAddrName__I = v || undefined;
      this.fromAddrNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get fromAddrName() {
    return this.fromAddrName__I;
  }
  fromAddrOnly__I?: string = undefined;
  fromAddrOnlyIsSet: boolean = false;
  set fromAddrOnly(v: undefined | string) {
    if (v !== undefined) {
      this.fromAddrOnly__I = v;
      this.fromAddrOnlyIsSet = true;
    } else {
      this.fromAddrOnly__I = v || undefined;
      this.fromAddrOnlyIsSet = false;
    }
    this.changeTracker = true;
  }
  get fromAddrOnly() {
    return this.fromAddrOnly__I;
  }
  optOutGrpId__I?: OptOutGroupRefTracked = undefined;
  optOutGrpIdIsSet: boolean = false;
  set optOutGrpId(v: undefined | OptOutGroupRefTracked) {
    if (v !== undefined) {
      this.optOutGrpId__I = v;
      this.optOutGrpIdIsSet = true;
    } else {
      this.optOutGrpId__I = v || undefined;
      this.optOutGrpIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get optOutGrpId() {
    return this.optOutGrpId__I;
  }
  replyTo__I?: string = undefined;
  replyToIsSet: boolean = false;
  set replyTo(v: undefined | string) {
    if (v !== undefined) {
      this.replyTo__I = v;
      this.replyToIsSet = true;
    } else {
      this.replyTo__I = v || undefined;
      this.replyToIsSet = false;
    }
    this.changeTracker = true;
  }
  get replyTo() {
    return this.replyTo__I;
  }
  hidden__I?: boolean = undefined;
  hiddenIsSet: boolean = false;
  set hidden(v: undefined | boolean) {
    if (v !== undefined) {
      this.hidden__I = v;
      this.hiddenIsSet = true;
    } else {
      this.hidden__I = v || undefined;
      this.hiddenIsSet = false;
    }
    this.changeTracker = true;
  }
  get hidden() {
    return this.hidden__I;
  }
  constructor(config?: EmailContentBaseOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.emailGroupId?.setIds();

    this.optOutGrpId?.setIds();
  }
  assignFrom(
    config: EmailContentBaseOptional,
    options?: AssignOptions,
  ): EmailContentBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.updatedOn && this.updatedOnApplyFilter(optionsRequired.filter)) {
      this.updatedOn = config.updatedOn;
      if (optionsRequired.unassign) this.updatedOnIsSet = false;
      else this.updatedOnIsSet = true;
    }
    if (config.updatedBy && this.updatedByApplyFilter(optionsRequired.filter)) {
      this.updatedBy = config.updatedBy;
      if (optionsRequired.unassign) this.updatedByIsSet = false;
      else this.updatedByIsSet = true;
    }
    if (config.createdOn && this.createdOnApplyFilter(optionsRequired.filter)) {
      this.createdOn = config.createdOn;
      if (optionsRequired.unassign) this.createdOnIsSet = false;
      else this.createdOnIsSet = true;
    }
    if (config.createdBy && this.createdByApplyFilter(optionsRequired.filter)) {
      this.createdBy = config.createdBy;
      if (optionsRequired.unassign) this.createdByIsSet = false;
      else this.createdByIsSet = true;
    }
    if (config.fromAddr && this.fromAddrApplyFilter(optionsRequired.filter)) {
      this.fromAddr = config.fromAddr;
      if (optionsRequired.unassign) this.fromAddrIsSet = false;
      else this.fromAddrIsSet = true;
    }
    if (config.ccAddr && this.ccAddrApplyFilter(optionsRequired.filter)) {
      this.ccAddr = config.ccAddr;
      if (optionsRequired.unassign) this.ccAddrIsSet = false;
      else this.ccAddrIsSet = true;
    }
    if (config.bccAddr && this.bccAddrApplyFilter(optionsRequired.filter)) {
      this.bccAddr = config.bccAddr;
      if (optionsRequired.unassign) this.bccAddrIsSet = false;
      else this.bccAddrIsSet = true;
    }
    if (config.subject && this.subjectApplyFilter(optionsRequired.filter)) {
      this.subject = config.subject;
      if (optionsRequired.unassign) this.subjectIsSet = false;
      else this.subjectIsSet = true;
    }
    if (config.plainBody && this.plainBodyApplyFilter(optionsRequired.filter)) {
      this.plainBody = config.plainBody;
      if (optionsRequired.unassign) this.plainBodyIsSet = false;
      else this.plainBodyIsSet = true;
    }
    if (config.htmlBody && this.htmlBodyApplyFilter(optionsRequired.filter)) {
      this.htmlBody = config.htmlBody;
      if (optionsRequired.unassign) this.htmlBodyIsSet = false;
      else this.htmlBodyIsSet = true;
    }
    if (
      config.description &&
      this.descriptionApplyFilter(optionsRequired.filter)
    ) {
      this.description = config.description;
      if (optionsRequired.unassign) this.descriptionIsSet = false;
      else this.descriptionIsSet = true;
    }
    if (config.title && this.titleApplyFilter(optionsRequired.filter)) {
      this.title = config.title;
      if (optionsRequired.unassign) this.titleIsSet = false;
      else this.titleIsSet = true;
    }
    if (
      config.emailGroupId &&
      this.emailGroupIdApplyFilter(optionsRequired.filter)
    ) {
      this.emailGroupId = new EmailContentGroupRefTracked(
        config.emailGroupId,
        options,
      );
      if (optionsRequired.unassign) this.emailGroupIdIsSet = false;
      else this.emailGroupIdIsSet = true;
    }
    if (
      config.recGroupId &&
      this.recGroupIdApplyFilter(optionsRequired.filter)
    ) {
      this.recGroupId = config.recGroupId;
      if (optionsRequired.unassign) this.recGroupIdIsSet = false;
      else this.recGroupIdIsSet = true;
    }
    if (
      config.htmlBodyClob &&
      this.htmlBodyClobApplyFilter(optionsRequired.filter)
    ) {
      this.htmlBodyClob = config.htmlBodyClob;
      if (optionsRequired.unassign) this.htmlBodyClobIsSet = false;
      else this.htmlBodyClobIsSet = true;
    }
    if (
      config.fromAddrName &&
      this.fromAddrNameApplyFilter(optionsRequired.filter)
    ) {
      this.fromAddrName = config.fromAddrName;
      if (optionsRequired.unassign) this.fromAddrNameIsSet = false;
      else this.fromAddrNameIsSet = true;
    }
    if (
      config.fromAddrOnly &&
      this.fromAddrOnlyApplyFilter(optionsRequired.filter)
    ) {
      this.fromAddrOnly = config.fromAddrOnly;
      if (optionsRequired.unassign) this.fromAddrOnlyIsSet = false;
      else this.fromAddrOnlyIsSet = true;
    }
    if (
      config.optOutGrpId &&
      this.optOutGrpIdApplyFilter(optionsRequired.filter)
    ) {
      this.optOutGrpId = new OptOutGroupRefTracked(config.optOutGrpId, options);
      if (optionsRequired.unassign) this.optOutGrpIdIsSet = false;
      else this.optOutGrpIdIsSet = true;
    }
    if (config.replyTo && this.replyToApplyFilter(optionsRequired.filter)) {
      this.replyTo = config.replyTo;
      if (optionsRequired.unassign) this.replyToIsSet = false;
      else this.replyToIsSet = true;
    }
    if (config.hidden && this.hiddenApplyFilter(optionsRequired.filter)) {
      this.hidden = config.hidden;
      if (optionsRequired.unassign) this.hiddenIsSet = false;
      else this.hiddenIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): EmailContentBaseTrackedI {
    const cloned = {} as EmailContentBaseTrackedI;
    if (
      this.updatedOnIsSetDeep() &&
      this.updatedOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedOnIsSet = true;
      cloned.updatedOn = this.updatedOn;
    } else {
      //cloned.updatedOnIsSet = false
    }
    if (
      this.updatedByIsSetDeep() &&
      this.updatedByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedByIsSet = true;
      cloned.updatedBy = this.updatedBy;
    } else {
      //cloned.updatedByIsSet = false
    }
    if (
      this.createdOnIsSetDeep() &&
      this.createdOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdOnIsSet = true;
      cloned.createdOn = this.createdOn;
    } else {
      //cloned.createdOnIsSet = false
    }
    if (
      this.createdByIsSetDeep() &&
      this.createdByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdByIsSet = true;
      cloned.createdBy = this.createdBy;
    } else {
      //cloned.createdByIsSet = false
    }
    if (
      this.fromAddrIsSetDeep() &&
      this.fromAddrApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.fromAddrIsSet = true;
      cloned.fromAddr = this.fromAddr;
    } else {
      //cloned.fromAddrIsSet = false
    }
    if (
      this.ccAddrIsSetDeep() &&
      this.ccAddrApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ccAddrIsSet = true;
      cloned.ccAddr = this.ccAddr;
    } else {
      //cloned.ccAddrIsSet = false
    }
    if (
      this.bccAddrIsSetDeep() &&
      this.bccAddrApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.bccAddrIsSet = true;
      cloned.bccAddr = this.bccAddr;
    } else {
      //cloned.bccAddrIsSet = false
    }
    if (
      this.subjectIsSetDeep() &&
      this.subjectApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.subjectIsSet = true;
      cloned.subject = this.subject;
    } else {
      //cloned.subjectIsSet = false
    }
    if (
      this.plainBodyIsSetDeep() &&
      this.plainBodyApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.plainBodyIsSet = true;
      cloned.plainBody = this.plainBody;
    } else {
      //cloned.plainBodyIsSet = false
    }
    if (
      this.htmlBodyIsSetDeep() &&
      this.htmlBodyApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.htmlBodyIsSet = true;
      cloned.htmlBody = this.htmlBody;
    } else {
      //cloned.htmlBodyIsSet = false
    }
    if (
      this.descriptionIsSetDeep() &&
      this.descriptionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.descriptionIsSet = true;
      cloned.description = this.description;
    } else {
      //cloned.descriptionIsSet = false
    }
    if (
      this.titleIsSetDeep() &&
      this.titleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.titleIsSet = true;
      cloned.title = this.title;
    } else {
      //cloned.titleIsSet = false
    }
    if (
      this.emailGroupIdIsSetDeep() &&
      this.emailGroupIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.emailGroupIdIsSet = true;
      cloned.emailGroupId = this.emailGroupId?.removeUnset(filter);
    } else {
      //cloned.emailGroupIdIsSet = false
    }
    if (
      this.recGroupIdIsSetDeep() &&
      this.recGroupIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.recGroupIdIsSet = true;
      cloned.recGroupId = this.recGroupId;
    } else {
      //cloned.recGroupIdIsSet = false
    }
    if (
      this.htmlBodyClobIsSetDeep() &&
      this.htmlBodyClobApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.htmlBodyClobIsSet = true;
      cloned.htmlBodyClob = this.htmlBodyClob;
    } else {
      //cloned.htmlBodyClobIsSet = false
    }
    if (
      this.fromAddrNameIsSetDeep() &&
      this.fromAddrNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.fromAddrNameIsSet = true;
      cloned.fromAddrName = this.fromAddrName;
    } else {
      //cloned.fromAddrNameIsSet = false
    }
    if (
      this.fromAddrOnlyIsSetDeep() &&
      this.fromAddrOnlyApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.fromAddrOnlyIsSet = true;
      cloned.fromAddrOnly = this.fromAddrOnly;
    } else {
      //cloned.fromAddrOnlyIsSet = false
    }
    if (
      this.optOutGrpIdIsSetDeep() &&
      this.optOutGrpIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.optOutGrpIdIsSet = true;
      cloned.optOutGrpId = this.optOutGrpId?.removeUnset(filter);
    } else {
      //cloned.optOutGrpIdIsSet = false
    }
    if (
      this.replyToIsSetDeep() &&
      this.replyToApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.replyToIsSet = true;
      cloned.replyTo = this.replyTo;
    } else {
      //cloned.replyToIsSet = false
    }
    if (
      this.hiddenIsSetDeep() &&
      this.hiddenApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.hiddenIsSet = true;
      cloned.hidden = this.hidden;
    } else {
      //cloned.hiddenIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): EmailContentBaseTrackedI {
    if (!this.updatedOnApplyFilter(filter)) this.updatedOnIsSet = false;

    if (!this.updatedByApplyFilter(filter)) this.updatedByIsSet = false;

    if (!this.createdOnApplyFilter(filter)) this.createdOnIsSet = false;

    if (!this.createdByApplyFilter(filter)) this.createdByIsSet = false;

    if (!this.fromAddrApplyFilter(filter)) this.fromAddrIsSet = false;

    if (!this.ccAddrApplyFilter(filter)) this.ccAddrIsSet = false;

    if (!this.bccAddrApplyFilter(filter)) this.bccAddrIsSet = false;

    if (!this.subjectApplyFilter(filter)) this.subjectIsSet = false;

    if (!this.plainBodyApplyFilter(filter)) this.plainBodyIsSet = false;

    if (!this.htmlBodyApplyFilter(filter)) this.htmlBodyIsSet = false;

    if (!this.descriptionApplyFilter(filter)) this.descriptionIsSet = false;

    if (!this.titleApplyFilter(filter)) this.titleIsSet = false;

    if (!this.emailGroupIdApplyFilter(filter)) this.emailGroupIdIsSet = false;
    this.emailGroupId?.unassignAll(filter);

    if (!this.recGroupIdApplyFilter(filter)) this.recGroupIdIsSet = false;

    if (!this.htmlBodyClobApplyFilter(filter)) this.htmlBodyClobIsSet = false;

    if (!this.fromAddrNameApplyFilter(filter)) this.fromAddrNameIsSet = false;

    if (!this.fromAddrOnlyApplyFilter(filter)) this.fromAddrOnlyIsSet = false;

    if (!this.optOutGrpIdApplyFilter(filter)) this.optOutGrpIdIsSet = false;
    this.optOutGrpId?.unassignAll(filter);

    if (!this.replyToApplyFilter(filter)) this.replyToIsSet = false;

    if (!this.hiddenApplyFilter(filter)) this.hiddenIsSet = false;

    return this;
  }
  updatedOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentBaseMeta.updatedOn,
      EmailContentBaseMeta,
      this.updatedOn,
      this,
    );
  }
  updatedOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedOnIsSet && this.updatedOnApplyFilter(filter)) return true;

    return false;
  }
  updatedByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentBaseMeta.updatedBy,
      EmailContentBaseMeta,
      this.updatedBy,
      this,
    );
  }
  updatedByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedByIsSet && this.updatedByApplyFilter(filter)) return true;

    return false;
  }
  createdOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentBaseMeta.createdOn,
      EmailContentBaseMeta,
      this.createdOn,
      this,
    );
  }
  createdOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdOnIsSet && this.createdOnApplyFilter(filter)) return true;

    return false;
  }
  createdByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentBaseMeta.createdBy,
      EmailContentBaseMeta,
      this.createdBy,
      this,
    );
  }
  createdByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdByIsSet && this.createdByApplyFilter(filter)) return true;

    return false;
  }
  fromAddrApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentBaseMeta.fromAddr,
      EmailContentBaseMeta,
      this.fromAddr,
      this,
    );
  }
  fromAddrIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.fromAddrIsSet && this.fromAddrApplyFilter(filter)) return true;

    return false;
  }
  ccAddrApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentBaseMeta.ccAddr,
      EmailContentBaseMeta,
      this.ccAddr,
      this,
    );
  }
  ccAddrIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ccAddrIsSet && this.ccAddrApplyFilter(filter)) return true;

    return false;
  }
  bccAddrApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentBaseMeta.bccAddr,
      EmailContentBaseMeta,
      this.bccAddr,
      this,
    );
  }
  bccAddrIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.bccAddrIsSet && this.bccAddrApplyFilter(filter)) return true;

    return false;
  }
  subjectApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentBaseMeta.subject,
      EmailContentBaseMeta,
      this.subject,
      this,
    );
  }
  subjectIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.subjectIsSet && this.subjectApplyFilter(filter)) return true;

    return false;
  }
  plainBodyApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentBaseMeta.plainBody,
      EmailContentBaseMeta,
      this.plainBody,
      this,
    );
  }
  plainBodyIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.plainBodyIsSet && this.plainBodyApplyFilter(filter)) return true;

    return false;
  }
  htmlBodyApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentBaseMeta.htmlBody,
      EmailContentBaseMeta,
      this.htmlBody,
      this,
    );
  }
  htmlBodyIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.htmlBodyIsSet && this.htmlBodyApplyFilter(filter)) return true;

    return false;
  }
  descriptionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentBaseMeta.description,
      EmailContentBaseMeta,
      this.description,
      this,
    );
  }
  descriptionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.descriptionIsSet && this.descriptionApplyFilter(filter))
      return true;

    return false;
  }
  titleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentBaseMeta.title,
      EmailContentBaseMeta,
      this.title,
      this,
    );
  }
  titleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.titleIsSet && this.titleApplyFilter(filter)) return true;

    return false;
  }
  emailGroupIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentBaseMeta.emailGroupId,
      EmailContentBaseMeta,
      this.emailGroupId,
      this,
    );
  }
  emailGroupIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.emailGroupIdIsSet && this.emailGroupIdApplyFilter(filter))
      return true;
    return this.emailGroupId?.anySet(filter) == true;

    return false;
  }
  recGroupIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentBaseMeta.recGroupId,
      EmailContentBaseMeta,
      this.recGroupId,
      this,
    );
  }
  recGroupIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.recGroupIdIsSet && this.recGroupIdApplyFilter(filter)) return true;

    return false;
  }
  htmlBodyClobApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentBaseMeta.htmlBodyClob,
      EmailContentBaseMeta,
      this.htmlBodyClob,
      this,
    );
  }
  htmlBodyClobIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.htmlBodyClobIsSet && this.htmlBodyClobApplyFilter(filter))
      return true;

    return false;
  }
  fromAddrNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentBaseMeta.fromAddrName,
      EmailContentBaseMeta,
      this.fromAddrName,
      this,
    );
  }
  fromAddrNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.fromAddrNameIsSet && this.fromAddrNameApplyFilter(filter))
      return true;

    return false;
  }
  fromAddrOnlyApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentBaseMeta.fromAddrOnly,
      EmailContentBaseMeta,
      this.fromAddrOnly,
      this,
    );
  }
  fromAddrOnlyIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.fromAddrOnlyIsSet && this.fromAddrOnlyApplyFilter(filter))
      return true;

    return false;
  }
  optOutGrpIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentBaseMeta.optOutGrpId,
      EmailContentBaseMeta,
      this.optOutGrpId,
      this,
    );
  }
  optOutGrpIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.optOutGrpIdIsSet && this.optOutGrpIdApplyFilter(filter))
      return true;
    return this.optOutGrpId?.anySet(filter) == true;

    return false;
  }
  replyToApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentBaseMeta.replyTo,
      EmailContentBaseMeta,
      this.replyTo,
      this,
    );
  }
  replyToIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.replyToIsSet && this.replyToApplyFilter(filter)) return true;

    return false;
  }
  hiddenApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentBaseMeta.hidden,
      EmailContentBaseMeta,
      this.hidden,
      this,
    );
  }
  hiddenIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.hiddenIsSet && this.hiddenApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.updatedOnIsSetDeep(filter)) return true;
    if (this.updatedByIsSetDeep(filter)) return true;
    if (this.createdOnIsSetDeep(filter)) return true;
    if (this.createdByIsSetDeep(filter)) return true;
    if (this.fromAddrIsSetDeep(filter)) return true;
    if (this.ccAddrIsSetDeep(filter)) return true;
    if (this.bccAddrIsSetDeep(filter)) return true;
    if (this.subjectIsSetDeep(filter)) return true;
    if (this.plainBodyIsSetDeep(filter)) return true;
    if (this.htmlBodyIsSetDeep(filter)) return true;
    if (this.descriptionIsSetDeep(filter)) return true;
    if (this.titleIsSetDeep(filter)) return true;
    if (this.emailGroupIdIsSetDeep(filter)) return true;
    if (this.recGroupIdIsSetDeep(filter)) return true;
    if (this.htmlBodyClobIsSetDeep(filter)) return true;
    if (this.fromAddrNameIsSetDeep(filter)) return true;
    if (this.fromAddrOnlyIsSetDeep(filter)) return true;
    if (this.optOutGrpIdIsSetDeep(filter)) return true;
    if (this.replyToIsSetDeep(filter)) return true;
    if (this.hiddenIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
